module.exports = __webpack_public_path__ + "static/market-research-53a0c938346abdbd21aa97c4f8aad3d4.png";